import React from 'react';
export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/sGMBffhghrgx2vuwjEWpx6/Kit_de_Terapia_Ocupacional_6_en_1.png';
type Props = {
  href?: string;
  className?: string;
  onClick?: () => void;
};

/** The product box. Always a link: to the purchase section, or to checkout. */
export function Mockup({
  href = '#compra',
  className = '',
  onClick
}: Props) {
  const external = href.startsWith('http');
  return <a href={href} onClick={onClick} target={external ? '_top' : undefined} aria-label="Ir a la sección de compra de Terapia Lista" className={`block transition-transform duration-200 ease-out hover:scale-[1.02] ${className}`} data-id="element-5" data-mp="zjekvrwvc0qk">
      <img src={MOCKUP_URL} alt="Kit Terapia Lista — 6 módulos en 1" className="mx-auto w-full mix-blend-multiply" data-id="element-6" data-mp="14k2cofsx8llu" />
    </a>;
}